import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import './StatisticsManagement.css';
import { getImageFileUrl, getVideoFileUrl } from '../../services/mediaService';

import Notification from '../Notification/Notification';

const TopMedia = () => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [token] = useState(localStorage.getItem('token') || '');

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleShowImage = async (item) => {
    let newImageUrl = '';
    try {
      if (item.type && item.type === 'video') {
        newImageUrl = getVideoFileUrl(item.id);
      } else {
        newImageUrl = getImageFileUrl(item.id);
      }

      window.open(newImageUrl, '_blank'); // új ablakban nyitja
    } catch (err) {
      console.error('Hiba a kép lekérésénél', err);
    }
  };

  const fetchTopMedia = useCallback(() => {
    fetch(`${apiUrl}/stats/top-media`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(json => {
        setNotification({ message: 'Sikeres lekérés!', type: 'success' });
        setData(json);
        setLoading(false);
      })
      .catch(() => {
        setNotification({ message: 'Hiba a lekérés során!', type: 'error' });
        setLoading(false);
      });
  }, [token, apiUrl]);

  useEffect(() => {
    fetchTopMedia();
  }, [fetchTopMedia]);


  return (
    <div className="stats-section">
      <h2 className="stats-title">Top Media</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="stats-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Type</th>
              <th>Views</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => (
              <tr key={item.id} className="hover:bg-gray-50">
                <td
                  className="border border-gray-300 p-2 clickable text-blue-600"
                  onClick={() => handleShowImage(item)}
                  title="Click to view image"
                >
                  {item.id}
                </td>

                <td className="border border-gray-300 p-2">{item.type}</td>
                <td className="border border-gray-300 p-2">{item.view_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <Notification
        message={notification.message}
        type={notification.type}
        duration={5000}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
};
const UserActivity = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = React.useState(true);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [token] = useState(localStorage.getItem('token') || '');

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchUserActivity = useCallback(() => {
    fetch(`${apiUrl}/stats/user-activity`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(json => {
        setNotification({ message: 'Sikeres lekérés!', type: 'success' });
        setActivities(json);
        setLoading(false);
      })
      .catch(() => {
        setNotification({ message: 'Hiba a lekérés során!', type: 'error' });
        setLoading(false);
      });
  }, [token, apiUrl]);

  useEffect(() => {
    fetchUserActivity();
  }, [fetchUserActivity]);

  return (
    <div className="stats-section">
      <h2 className="stats-title">User Activity</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="stats-table">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">User ID</th>
              <th className="border border-gray-300 p-2">Username</th>
              <th className="border border-gray-300 p-2">View Count</th>
            </tr>
          </thead>
          <tbody>
            {activities.map((a) => (
              <tr key={a.id} className="hover:bg-gray-50">
                <td className="border border-gray-300 p-2">{a.id}</td>
                <td className="border border-gray-300 p-2">{a.name}</td>
                <td className="border border-gray-300 p-2">{a.view_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <Notification
        message={notification.message}
        type={notification.type}
        duration={5000}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
};

const DailyViews = () => {
  const [views, setViews] = useState([]);
  const [loading, setLoading] = React.useState(true);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [token] = useState(localStorage.getItem('token') || '');

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchDailyViews = useCallback(() => {
    fetch(`${apiUrl}/stats/daily-views`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(json => {
        setNotification({ message: 'Sikeres lekérés!', type: 'success' });
        setViews(json);
        setLoading(false);
      })
      .catch(() => {
        setNotification({ message: 'Hiba a lekérés során!', type: 'error' });
        setLoading(false);
      });
  }, [token, apiUrl]);

  useEffect(() => {
    fetchDailyViews();
  }, [fetchDailyViews]);

  const formatDate = (iso) => {
    if (!iso) return '-';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleDateString('hu-HU');
  };

  return (
    <div className="stats-section">
      <h2 className="stats-title">Daily Views</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="stats-table">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">Date</th>
              <th className="border border-gray-300 p-2">Views</th>
            </tr>
          </thead>
          <tbody>
            {views.map((v, i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="border border-gray-300 p-2">
                  {formatDate(v.day)}
                </td>
                <td className="border border-gray-300 p-2">
                  {v.views_per_day}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Notification
        message={notification.message}
        type={notification.type}
        duration={5000}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
};

const Uploads = () => {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = React.useState(true);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [token] = useState(localStorage.getItem('token') || '');

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchUploads = useCallback(() => {
    fetch(`${apiUrl}/stats/uploads`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => res.json())
      .then((json) => {
        setNotification({ message: 'Sikeres lekérés!', type: 'success' });
        setUploads(json);
        setLoading(false);
      })
      .catch(() => {
        setNotification({ message: 'Hiba a lekérés során!', type: 'error' });
        setLoading(false);
      });
  }, [token, apiUrl]);

  useEffect(() => {
    fetchUploads();
  }, [fetchUploads]);

  return (
    <div className="stats-section">
      <h2 className="stats-title">Uploads</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="stats-table">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">Username</th>
              <th className="border border-gray-300 p-2">Upload Count</th>
            </tr>
          </thead>
          <tbody>
            {uploads.map((u, i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="border border-gray-300 p-2">{u.name}</td>
                <td className="border border-gray-300 p-2">{u.upload_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Notification
        message={notification.message}
        type={notification.type}
        duration={5000}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
};

const LoginCount = () => {
  const [logins, setLogins] = useState([]);
  const [loading, setLoading] = React.useState(true);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [token] = useState(localStorage.getItem('token') || '');

  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchLoginCount = useCallback(() => {
    fetch(`${apiUrl}/stats/login-count`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => res.json())
      .then((json) => {
        setNotification({ message: 'Sikeres lekérés!', type: 'success' });
        setLogins(json);
        setLoading(false);
      })
      .catch(() => {
        setNotification({ message: 'Hiba a lekérés során!', type: 'error' });
        setLoading(false);
      });
  }, [token, apiUrl]);

  useEffect(() => {
    fetchLoginCount();
  }, [fetchLoginCount]);

  return (
    <div className="stats-section">
      <h2 className="stats-title">Login Count</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="stats-table">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 p-2">User ID</th>
              <th className="border border-gray-300 p-2">Username</th>
              <th className="border border-gray-300 p-2">Login Count</th>
            </tr>
          </thead>
          <tbody>
            {logins.map((l) => (
              <tr key={l.id} className="hover:bg-gray-50">
                <td className="border border-gray-300 p-2">{l.id}</td>
                <td className="border border-gray-300 p-2">{l.name}</td>
                <td className="border border-gray-300 p-2">{l.login_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Notification
        message={notification.message}
        type={notification.type}
        duration={5000}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
};

const ParentCategories = () => {
  const [parents, setParents] = useState([]);
  const [children, setChildren] = useState({});
  const [expandedParents, setExpandedParents] = useState({});
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token") || "";
  const apiUrl = process.env.REACT_APP_API_URL;

  // ---- SZÜLŐ LISTA LEKÉRÉSE ----
  const fetchParents = useCallback(() => {
    fetch(`${apiUrl}/stats/parent-categories`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((json) => {
        setParents(json || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [apiUrl, token]);

  useEffect(() => {
    fetchParents();
  }, [fetchParents]);

  // ---- GYEREK LISTA LEKÉRÉSE ----
  const fetchChildren = async (parentId) => {
    const res = await fetch(`${apiUrl}/stats/child-categories/${parentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    return data || [];
  };

  // ---- PARENT TOGGLE ----
  const toggleParent = async (parentId) => {
    if (expandedParents[parentId]) {
      // bezárás
      setExpandedParents((prev) => ({ ...prev, [parentId]: false }));
      return;
    }

    // ha még nincs letöltve
    if (!children[parentId]) {
      try {
        const data = await fetchChildren(parentId);
        setChildren((prev) => ({ ...prev, [parentId]: data }));
      } catch {
        setChildren((prev) => ({ ...prev, [parentId]: [] }));
      }
    }

    // nyitás
    setExpandedParents((prev) => ({ ...prev, [parentId]: true }));
  };

  return (
    <div className="container mt-4">
      <h2>Parent Categories</h2>

      {loading ? (
        <p>Betöltés...</p>
      ) : (
        <table className="table table-bordered table-hover mt-3">
          <thead className="table-light">
            <tr>
              <th style={{ width: "40%" }}>Kategória</th>
              <th>Képek</th>
              <th>Videók</th>
            </tr>
          </thead>
          <tbody>
            {parents.map((p) => {
              // backend mezőnevek összehangolása
              const parentId =
                p.parent_id ?? p.category_id ?? p.id;

              const parentName =
                p.parent_name ?? p.category_name ?? p.name;

              return (
                <React.Fragment key={parentId}>
                  {/* --- SZÜLŐ SOR --- */}
                  <tr
                    className="table-primary parent-row"
                    onClick={() => toggleParent(parentId)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="text-start">
                      <span className="parent-arrow me-2">
                        {expandedParents[parentId] ? "▼" : "►"}
                      </span>
                      <strong>{parentName}</strong>
                    </td>
                    <td>{p.image_count ?? 0}</td>
                    <td>{p.video_count ?? 0}</td>
                  </tr>

                  {/* --- GYEREK SOROK --- */}
                  {expandedParents[parentId] &&
                    (children[parentId]?.length ? (
                      children[parentId].map((c) => (
                        <tr key={c.category_id} className="table-warning child-row">
                          <td className="text-start ps-4">
                            <span style={{ marginRight: 6 }}>•</span>
                            {c.category_name}
                          </td>
                          <td>{c.image_count ?? 0}</td>
                          <td>{c.video_count ?? 0}</td>
                        </tr>
                      ))
                    ) : (
                      <tr key={`${parentId}-none`} className="table-light">
                        <td colSpan={3} className="ps-4 fst-italic">
                          Nincsenek gyerek kategóriák.
                        </td>
                      </tr>
                    ))}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

const Storage = () => {
  const [data, setData] = useState(null);
  const token = localStorage.getItem("token") || "";
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${apiUrl}/storage/df`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(json => setData(json))
      .catch(err => console.error(err));
  }, []);

  if (!data) return <p>Betöltés...</p>;

  const percent = parseInt(data.usePercent.replace("%", ""), 10);
  const barClass =
    percent > 90 ? "bg-danger" :
      percent > 75 ? "bg-warning" :
        "bg-success";

  return (
    <table className="table table-bordered table-hover mt-3">
      <thead className="table-light">
        <tr>
          <th style={{ width: "30%" }}>Fájlrendszer</th>
          <th style={{ width: "20%" }}>Használt</th>
          <th style={{ width: "20%" }}>Szabad</th>
          <th style={{ width: "30%" }}>Kihasználtság</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="text-start">
            <strong>{data.filesystem}</strong>
            <div className="text-muted small">
              mount: {data.mount}
            </div>
          </td>

          <td>
            {data.used} / {data.size}
          </td>

          <td>{data.available}</td>

          <td>
            <div className="d-flex align-items-center gap-2">
              <div className="progress flex-grow-1" style={{ height: 18 }}>
                <div
                  className={`progress-bar ${barClass}`}
                  role="progressbar"
                  style={{ width: `${percent}%` }}
                  aria-valuenow={percent}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
              <span className="fw-semibold">{percent}%</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );

};

export default function StatisticsManagement() {
  return (
    <div className="statistics-container">
      <Routes>
        <Route path="top-media" element={<TopMedia />} />
        <Route path="user-activity" element={<UserActivity />} />
        <Route path="daily-views" element={<DailyViews />} />
        <Route path="uploads" element={<Uploads />} />
        <Route path="login-count" element={<LoginCount />} />
        <Route path="parent-categories" element={<ParentCategories />} />
        <Route path="storage" element={<Storage />} />

      </Routes>
    </div>
  );
}
